import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { useTenant } from '../../context/TenantContext';
import Icon from '../../components/common/Icon';

export default function SuperAdminLogin() {
  const { login }   = useAuth();
  const tenant      = useTenant();
  const navigate    = useNavigate();
  const primary     = tenant?.primaryColor || '#0085CA';
  const accent      = tenant?.accentColor  || '#003D6B';

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  async function submit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.login({ username, password, method: 'local' });
      if (!['superadmin', 'admin'].includes(res.agent?.role)) {
        setError('Acceso restringido — se requiere rol de administrador');
        return;
      }
      login(res.agent, res.token);
      navigate('/superadmin');
    } catch (err) {
      setError(err.message || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'#F0F2F5', fontFamily:'var(--font-body, Arial, sans-serif)',
    }}>
      <div style={{
        width:380, background:'#fff', borderRadius:12,
        boxShadow:'0 4px 24px rgba(0,0,0,.08)',
        overflow:'hidden',
      }}>
        {/* Header con color del tenant */}
        <div style={{
          background: accent, padding:'28px 32px 24px',
          display:'flex', flexDirection:'column', alignItems:'center', gap:12,
        }}>
          {/* Logo o icono 4 cuadros */}
          {tenant?.logoUrl ? (
            <img src={tenant.logoUrl} alt={tenant.appName} style={{height:40,objectFit:'contain',filter:'brightness(10)'}} />
          ) : (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect x="2"  y="2"  width="12" height="12" rx="3" fill={primary}/>
              <rect x="18" y="2"  width="12" height="12" rx="3" fill="rgba(255,255,255,.4)"/>
              <rect x="2"  y="18" width="12" height="12" rx="3" fill="rgba(255,255,255,.4)"/>
              <rect x="18" y="18" width="12" height="12" rx="3" fill={primary}/>
            </svg>
          )}
          <div style={{color:'#fff', fontSize:13, fontWeight:500, opacity:.85, letterSpacing:.3}}>
            {tenant?.appName || 'HelpDesk TI'}
          </div>
        </div>

        {/* Formulario */}
        <div style={{padding:'28px 32px 32px'}}>
          <div style={{marginBottom:20, textAlign:'center'}}>
            <div style={{fontSize:16, fontWeight:700, color:'#111827', marginBottom:4}}>
              Acceso Administración
            </div>
            <div style={{fontSize:12, color:'#6B7280'}}>
              Panel de superadministrador
            </div>
          </div>

          <form onSubmit={submit} style={{display:'flex', flexDirection:'column', gap:14}}>
            {/* Usuario */}
            <div>
              <label style={{fontSize:12, fontWeight:600, color:'#374151', display:'block', marginBottom:5}}>
                Usuario
              </label>
              <div style={{position:'relative'}}>
                <span style={{position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', display:'flex', alignItems:'center'}}>
                  <Icon name="person" size={16} style={{color:'#9CA3AF'}}/>
                </span>
                <input
                  type="text"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  autoFocus
                  placeholder="nombre.usuario"
                  required
                  style={{
                    width:'100%', boxSizing:'border-box',
                    border:'1px solid #D1D5DB', borderRadius:8,
                    padding:'9px 12px 9px 32px', fontSize:13,
                    outline:'none', color:'#111827',
                    fontFamily:'inherit',
                  }}
                />
              </div>
            </div>

            {/* Contraseña */}
            <div>
              <label style={{fontSize:12, fontWeight:600, color:'#374151', display:'block', marginBottom:5}}>
                Contraseña
              </label>
              <div style={{position:'relative'}}>
                <span style={{position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', display:'flex', alignItems:'center'}}>
                  <Icon name="lock" size={16} style={{color:'#9CA3AF'}}/>
                </span>
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  style={{
                    width:'100%', boxSizing:'border-box',
                    border:'1px solid #D1D5DB', borderRadius:8,
                    padding:'9px 36px 9px 32px', fontSize:13,
                    outline:'none', color:'#111827',
                    fontFamily:'inherit',
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(p => !p)}
                  style={{
                    position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
                    background:'none', border:'none', cursor:'pointer', padding:0,
                    display:'flex', alignItems:'center', color:'#9CA3AF',
                  }}
                >
                  <Icon name={showPass ? 'visibility_off' : 'visibility'} size={16}/>
                </button>
              </div>
            </div>

            {/* Error */}
            {error && (
              <div style={{
                background:'#FEF2F2', border:'1px solid #FECACA',
                borderRadius:8, padding:'8px 12px',
                fontSize:12, color:'#B91C1C', display:'flex', alignItems:'center', gap:6,
              }}>
                <Icon name="error" size={14} style={{flexShrink:0}}/>
                {error}
              </div>
            )}

            {/* Botón */}
            <button
              type="submit"
              disabled={loading || !username.trim() || !password}
              style={{
                width:'100%', height:40, borderRadius:8, border:'none',
                background: (!loading && username.trim() && password) ? accent : '#E5E7EB',
                color: (!loading && username.trim() && password) ? '#fff' : '#9CA3AF',
                fontSize:13, fontWeight:600, cursor: loading ? 'wait' : 'pointer',
                display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                transition:'background .15s',
              }}
            >
              {loading
                ? <><span style={{width:14,height:14,border:'2px solid rgba(255,255,255,.4)',borderTopColor:'#fff',borderRadius:'50%',display:'inline-block',animation:'spin .7s linear infinite'}}/> Entrando…</>
                : 'Acceder al panel'
              }
            </button>
          </form>

          {/* Volver al login normal */}
          <div style={{marginTop:16, textAlign:'center'}}>
            <a href="/login" style={{fontSize:11, color:'#9CA3AF', textDecoration:'none'}}>
              ← Volver al login de agentes
            </a>
          </div>
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
